
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/storage",
      function () {
        return require("private-next-pages/storage.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/storage"])
      });
    }
  